<template>
	<div>
		<div class="col-md-12">
			<div class="row" style="margin-top:20px">
				<div class="col-md-6">
					<h3 class="page-header">
						<i class="fa fa-linode animated bounceInDown show-info"></i>
						Add Furniture Items
					</h3>
				</div>
				<div class="col-md-6 ">
					<div class="row">

					</div>
				</div>
			</div>
		</div>
		<div class="panel panel-cascade">
			<div class="panel-body">
				<div class="form-horizontal cascde-forms">
					<div class="col-md-12">
						<div class="form-group row">
							<div class="col-md-3">
								<label class="col-form-label ">Category<span
										style="color: rgba(255, 0, 0, 0.67)">*</span></label>
							</div>
							<div class="col-md-6">
								<div class="form-control form-cascade-control input-small">{{ category?.name }}</div>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label class="col-form-label ">Sub Category<span
										style="color: rgba(255, 0, 0, 0.67)">*</span></label>
							</div>
							<div class="col-md-6">
								<select class="form-control form-cascade-control input-small" 
									v-model="form.category_id">
									<option :value="0">Select</option>
									<option v-for="(item) in allcategories" :key="item.id" :value="item.id">{{
										item?.name }}</option>
								</select>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="subcategory" class="col-form-label control-label">Company</label>
							</div>
							<div class="col-md-6">
								<select v-model="brandid" class="form-control form-cascade-control input-small">
									<template v-if="brands!=null">
										<option v-for="filter in brands.predefinedvalues" :key="filter.id"
											:value="filter.id">{{ filter.value }}</option>
									</template>
								</select>
								<span class="invalid-feedback" role="alert">
									<strong></strong>
								</span>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label class="col-form-label ">Name<span
										style="color: rgba(255, 0, 0, 0.67)">*</span></label>
							</div>
							<div class="col-md-6">
								<input type="text" class="form-control form-cascade-control input-small"
									v-model="form.name">
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label class="col-form-label ">Description</label>
							</div>
							<div class="col-md-6">
								<textarea type="text" v-model="form.shortdescription"
									class="form-control form-cascade-control input-small"></textarea>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label class="col-form-label ">Youtube Link</label>
							</div>
							<div class="col-md-6">
								<input type="text" v-model="form.videourl"
									class="form-control form-cascade-control input-small">
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label class="col-form-label ">Price</label>
							</div>
							<div class="col-md-6">
								<input type="number" v-model="form.cp"
									class="form-control form-cascade-control input-small">
							</div>
						</div>

						<div class="col-md-12  text-center">
							<div class="row">
								<div class="col-md-4"></div>
								<div class="col-md-2">
									<input type="button" class="btn btn-primary" value="Submit" @click="onSubmit()" />
								</div>
								<div class="col-md-2">
									<input type="button" class="btn btn-danger btn-sm" @click="cancel()" value="Cancel" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
import axios from 'axios';
import Constants from '../../components/utilities/Constants.vue';
import { mapGetters } from 'vuex';
export default {
	mixins: [Constants],
	props: ['editfurniture'],
	components: {

	},
	data() {
		return {
			form: {
				id: 0,
				name:'',
				parent_id:0,
				category_id: 0,
				shortdescription: '',
				videourl: '',
				cp: 0,
				nameoninvoice:'',
				categoryids:''
				
			},
			allcategories:[],
			category:null,
			categoryid:0,
			brandid: 0,
			
			
		}
	},
	mounted() {
		if(this.furniturecategory == null) {
            this.$store.dispatch('fetchFurnitureCategory');
        }else {
            this.category = this.furniturecategory;
        }
		// this.fetchcategoryByname()
		this.$store.dispatch('fetchattributes')
		this.initialize();
		// this.fetchbrands()
	},

	computed: {
		...mapGetters(['attributes', 'selectedstoreid','furniturecategory']),

		brands() {
			let attribute = this.attributes.find(block => block.id == 2)
			return attribute
		},
		
	},
	watch:{
        furniturecategory: function(newVal) {
            if (newVal != null) {
                this.category = newVal;
            }
        },
    },
	methods: {
		initialize() {
			
			setTimeout(() => {
				this.refresh();
			}, 1000);
			if(this.editfurniture!=null){
				let furniture = this.editfurniture
				this.form.id = furniture.id
				this.form.name = furniture.name
				this.form.category_id = furniture.category_id 
				// this.fetchbrands()
				this.form.shortdescription = furniture.shortdescription 
				this.form.videourl = furniture.videourl 
				this.form.cp = furniture.cp 
				this.form.nameoninvoice = furniture.name 
				this.form.categoryids = furniture.categoryids 
				if (furniture.attribute != null) {
					let attribute = furniture.attribute.find(block => block.attribute_id == 2)
					if (typeof attribute !== 'undefined') {
						this.brandid = Number.parseInt(attribute.attribute_value_ids)
					}
				}
			}
		},
        refresh() {
           axios.post('api/category/by/parentid',{parent_id: this.category?.id})
                .then((response) => {
                    this.allcategories = response.data?.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
		onSubmit: function () {
			this.form.parent_id = this.category?.id ?? 0;
			this.form.categoryids = this.category?.id ?? 0;
			let attribute = { attribute_id: 2, ispredefined: 1, value: this.brandid }
			this.form.attributes = [];
			this.form.attributes.push(attribute);
			this.form.storeid = this.selectedstoreid
			this.form.nameoninvoice = this.form.name;
			

			console.log(this.form);
			if(this.form.name== ''){
				this.$notify({ text: 'Please enter name', type: 'warn' })
				return;
			}
			if(this.form.category_id== 0){
				this.$notify({ text: 'Please select sub category', type: 'warn' })
				return;
			}
			if(this.brandid== 0){
				this.$notify({ text: 'Please select brand', type: 'warn' })
				return;
			}
			if(this.form.cp== 0){
				this.$notify({ text: 'Please enter price', type: 'warn' })
				return;
			}
			this.$store.commit('assignloadingstatus', 1)
			axios.post('api/product/createupdate2',this.form)
				.then(response => {
					console.log(response.data);
					if (response.data.success == true) {
						this.$notify({
							text: 'Registered Successfully',
							type: 'success',
							duration: '80000',
							speed: '800',
							closeOnClick: false
						})
					} 
					this.cancel();
					this.$store.commit('assignloadingstatus', 0)
				})
				.catch(error => console.log(error));
		},
		cancel() {
			this.form = {
				id: 0,
				name:'',
				parent_id:0,
				category_id: 0,
				shortdescription: '',
				videourl: '',
				cp: 0,
				nameoninvoice:'',
				categoryids:''
			}
			// this.categoryid = 0;
			this.brandid = 0;
			this.allcategories = [];
			// this.category = null;
			if(this.editfurniture!=null){
				this.$emit('close')
			}
			this.$store.commit('assignloadingstatus', 0)
			
		},
		// fetchbrands() {
        //     let param = { 
		// 		// parentcategoryid: this.form.category_id,
		// 		 attributeid: 2 }
        //     window.axios.post('api/attribute/values/fetchbycategory', param)
        //         .then(response => this.processAvailableBrands(response.data))
        //         .catch(error => console.log(error));
        // },
		//  processAvailableBrands(data) {
        //     this.brands = data
		// 	if(this.editfurniture!=null){
		// 		if (this.editfurniture.attribute != null) {
		// 			let attribute = this.editfurniture.attribute.find(block => block.attribute_id == 2)
		// 			if (typeof attribute !== 'undefined') {
		// 				this.brandid = Number.parseInt(attribute.attribute_value_ids)
		// 			}
		// 		}
		// 	}
        // },
	}
}

</script>
